const _excluded = ["className", "children", "value", "height", "variant", "skin", "onClick", "label", "tooltipProps", "intent", "disabled"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { MenuItem as MuiMenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
import { Tooltip } from "../Tooltip";
import { useIntentBehavior } from "../IntentBehavior";
const isMultiline = p => p.variant === 'multiline';
const useStyles = makeStyles({
  root: {
    padding: p => "".concat(isMultiline(p) ? '16px' : '0', " 16px"),
    height: p => isMultiline(p) ? 'auto' : p.height || 40,
    whiteSpace: p => isMultiline(p) ? 'normal' : 'nowrap',
    display: p => isMultiline(p) ? 'block' : 'flex',
    gap: 12,
    fontSize: typography.fontSizeP1,
    fontFamily: typography.fontFamilyLight,
    // Removes the material-ui ripple element.
    '& .MuiTouchRipple-root': {
      display: 'none'
    },
    '&:hover, &:focus:not(.Mui-selected)': {
      backgroundColor: colors.dark70
    },
    '&.Mui-selected': {
      backgroundColor: colors.dark120
    },
    '&:not(:last-child)': {
      borderBottom: p => isMultiline(p) ? "1px solid ".concat(colors.dark200) : 'none'
    }
  },
  primary: {
    color: "".concat(colors.dark900, " !important") // necessary in case the item is an <a> element since old UI lib take over global link styles
  },
  secondary: {
    color: "".concat(colors.dark700, " !important") // necessary in case the item is an <a> element since old UI lib take over global link styles
  },
  error: {
    color: "".concat(colors.red950, " !important") // necessary in case the item is an <a> element since old UI lib take over global link styles
  }
});
export const MenuItem = /*#__PURE__*/React.forwardRef(function MenuItem(props, ref) {
  const {
      className,
      children,
      value,
      height,
      variant = 'singleline',
      skin = 'primary',
      onClick,
      label,
      tooltipProps,
      intent,
      disabled
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const overrides = useStyles({
    height,
    variant
  });
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltipProps !== null && tooltipProps !== void 0 && tooltipProps.title) || !!tooltipFromIntent;
  const menuItem = /*#__PURE__*/React.createElement(MuiMenuItem, _extends({
    className: cn(overrides.root, overrides[skin], className),
    ref: ref,
    alignItems: "center",
    value: value,
    onClick: onClick,
    "data-label": label || children,
    disabled: disabledFromIntent || disabled
  }, rest), children);
  return hasTooltip ? /*#__PURE__*/React.createElement(Tooltip, tooltipProps || {
    placement: 'top',
    title: tooltipFromIntent
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-wrapper")
  }, menuItem)) : menuItem;
});